module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fecd02c29554acc59d39a5fa1ef36f96.png";